<template>
  <v-container class="fill-height" fluid>
    <!-- ログイン中のローディング -->
    <div v-if="isNowLoggingIn()">
      <v-overlay z-index="1000">
        <v-card class="text-center black--text" color="white">
          <v-card-title>{{ $tt('customOAuthMessage') }}</v-card-title>
          <v-card-text>
            <v-progress-circular color="primary" indeterminate size="64"></v-progress-circular>
          </v-card-text>
        </v-card>
      </v-overlay>
    </div>
  </v-container>
</template>

<script>
import ApplicationConfig from '@/lib/application-config'
import i18n from '@/lib/i18n'
import locale from '@/lib/locale'
import storage from '@/lib/storage'
import axios from 'axios'
import Toast from '@/lib/toast'
import moment from 'moment'

export default {
  mounted() {
    this.oAuthLogin()
  },
  methods: {
    oAuthLogin() {
      const hash = this.$route.hash
      const cognitoBaseUrl = ApplicationConfig.getCognitoBaseUrl()
      i18n.setUserLangByLanguage(this.getLanguage())

      let args = {}
      const pair = hash.substring(1).split('&')
      for (var i = 0; pair[i]; i++) {
        let kv = pair[i].split('=')
        args[kv[0]] = kv[1]
      }

      if (args['error_description']) {
        Toast.error(decodeURIComponent(args['error_description']))
        this.$router.push({ name: 'Login' })
        return
      }

      if (args['access_token']) {
        const bearer = 'Bearer ' + args['access_token']
        // ユーザー情報の取得
        axios
          .get(cognitoBaseUrl + '/oauth2/userInfo', {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              Authorization: bearer,
            },
          })
          .then(userInfo => {
            const request = {
              email: userInfo.data.email,
              username: userInfo.data.username,
              nickname: userInfo.data.preferred_username,
              language: this.getLanguage(),
              zoneinfo: moment.tz.guess(), // バグ修正: 20230726 zoneinfo: locale.detectCurrent(),
              cognitoAccessToken: args['access_token'], // 送っているがauthサーバーでは受け取っていない
              cognitoIdToken: args['id_token'], // 送っているがauthサーバーでは受け取っていない
              onSignUpSuccessHandler: this.closeSignUpWindow,
              nextRoute: '/feed',
            }
            this.$store.dispatch('authOAuthLogin', request)
          })
          .catch(err => {
            Toast.i18nError('customOAuthGetUserInfoError')
            this.$router.push({ name: 'Login' })
          })
      }
    },

    isNowLoggingIn() {
      return this.$store.getters.nowLoggingIn
    },
    getLanguage() {
      return storage.getUserLangConsideringDefault()
    },
    closeSignUpWindow() {
      this.nowShowingAboutSignUp = false
    },
  },
  data: () => ({ nowShowingAboutSignUp: false }),
}
</script>
